const PermissionsCtrl = ['$scope', 'UserInfo', function($scope, UserInfo) {
        $scope.userHasPerm = function(perm){
            return UserInfo.hasPerm(perm);
        };
    }
]

export {PermissionsCtrl};